import React, { Component } from "react";
import { translate } from "react-i18next";
import { Modal, ModalBody, ModalHeader, ModalFooter, Button } from "reactstrap";

class ConfirmationModal extends Component {
  render() {
    const { isOpen, modalBody, deleteName, modalAction, t } = this.props;
    return (
      <Modal isOpen={isOpen}>
        <ModalHeader>
          {t("dashboard.delete")} {`${deleteName || ""}`}
        </ModalHeader>
        <ModalBody>
          {modalBody ? (
            modalBody
          ) : (
            <p>
              {t("dashboard.areYouSureYouWantToDelete")}{" "}
              <span style={{ textTransform: "lowercase" }}>
                {" "}
                {deleteName ? `${t("dashboard.this")} ${deleteName}` : ""}
              </span>{" "}
              ?
            </p>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="info" onClick={() => modalAction("confirm")}>
            {t("dashboard.confirm")}
          </Button>
          <Button color="secondary" onClick={() => modalAction("cancel")}>
            {t("dashboard.cancel")}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default translate("translations")(ConfirmationModal);
